// Older drafts and upload endpoints can use the public path without /api.
export function examAssetUrl(value) {
  if (typeof value !== "string") return "";
  const url = value.trim();
  if (/^\/?exam-assets\//.test(url)) return "/api/" + url.replace(/^\//, "");
  if (url.startsWith("api/exam-assets/")) return "/" + url;
  return url;
}
